/**
* pdf-lib class
*/
/* eslint-disable no-unused-vars */

import { PDFDocument, rgb, StandardFonts } from 'pdf-lib'

import download from 'downloadjs'

export default class PdfEditor {
  constructor() {
    this.fontSize = 10;
  }

  async createPdf(PDFName, transactions) {
    const pdfDoc = await PDFDocument.create()
    const helveticaBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold)
    const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
    
    const page = pdfDoc.addPage()
    const { width, height } = page.getSize()
    
    // Header section
    page.setFontSize(this.fontSize)
    let currentY = height - 40 // Start from top with margin

    // Draw header
    page.drawText('TAX INVOICE', {
      x: 40,
      y: currentY,
      font: helveticaBold,
      size: this.fontSize
    })
    currentY -= this.fontSize + 5

    page.drawText(transactions[0].EventName, {
      x: 40,
      y: currentY,
      font: helvetica,
      size: this.fontSize
    })
    currentY -= this.fontSize + 5

    page.drawText(`ABN: From Stall Holder??`, {
      x: 40,
      y: currentY,
      font: helvetica,
      size: this.fontSize
    })
    currentY -= this.fontSize + 5

    page.drawText(transactions[0].StallHolderName, {
      x: 40,
      y: currentY,
      font: helvetica,
      size: this.fontSize
    })
    currentY -= this.fontSize + 5

    page.drawText(transactions[0].StallName, {
      x: 40,
      y: currentY,
      font: helvetica,
      size: this.fontSize
    })
    currentY -= this.fontSize * 2 // Add extra space before table

    // Table headers
    const tableHeaders = ['Transaction ID', 'Date', 'Time', 'Terminal', 'Amount']
    const columnWidths = [100, 80, 60, 60, 80]
    const startX = 40
    let currentX = startX

    // Draw table headers
    tableHeaders.forEach((header, index) => {
      page.drawText(header, {
        x: currentX,
        y: currentY,
        font: helveticaBold,
        size: this.fontSize
      })
      currentX += columnWidths[index]
    })
    currentY -= this.fontSize + 5

    // Draw table rows
    let totalAmount = 0

    transactions.forEach(transaction => {
      currentX = startX

      // Transaction ID
      page.drawText(transaction.TransactionID, {
        x: currentX,
        y: currentY,
        font: helvetica,
        size: this.fontSize
      })
      currentX += columnWidths[0]

      // Date
      page.drawText(transaction.TimeCreated.substring(0, 10), {
        x: currentX,
        y: currentY,
        font: helvetica,
        size: this.fontSize
      })
      currentX += columnWidths[1]

      // Time
      page.drawText(transaction.TimeCreated.substring(11, 16), {
        x: currentX,
        y: currentY,
        font: helvetica,
        size: this.fontSize
      })
      currentX += columnWidths[2]

      // Terminal
      page.drawText(transaction.TerminalNumber, {
        x: currentX,
        y: currentY,
        font: helvetica,
        size: this.fontSize
      })
      currentX += columnWidths[3]

      // Amount
      const amount = parseFloat(transaction.Amount.replace(/[^0-9.-]+/g, ''))
      totalAmount += amount
      page.drawText(transaction.Amount, {
        x: currentX,
        y: currentY,
        font: helvetica,
        size: this.fontSize
      })
      currentY -= this.fontSize + 2
    })

    // Draw total
    currentY -= this.fontSize
    const totalText = `Total Amount: $${totalAmount.toFixed(2)}`
    page.drawText(totalText, {
      x: startX + columnWidths[0] + columnWidths[1] + columnWidths[2],
      y: currentY,
      font: helveticaBold,
      size: this.fontSize
    })

    const pdfBytes = await pdfDoc.save()
    download(pdfBytes, `${PDFName}.pdf`, "application/pdf")
    return pdfBytes
  }
}